import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { take } from 'rxjs/operators';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { ApiError, MessageService } from '../../../../core';
import { AreaSearchOrderBy } from '../../area-search-orderby';
import { AreaFilter } from '../../filter';
import { AreaSearchHttpService } from '../../services';
import { areaSituacaoAtiva } from '../../situacao';
import { AreaFormSelect } from '../form-select';

@Component({
    selector: 'sgt-area-multiselect',
    templateUrl: './area-multiselect.component.html',
    styleUrls: ['./area-multiselect.component.less']
})
export class AreaMultiselectComponent implements OnInit, OnDestroy {
    /** Áreas selecionadas */
    @Input() idsAreas: number[];
    /** Ao alterar a seleção das áreas */
    @Output() idsAreasChange = new EventEmitter<number[]>();

    /** Se deve exibir a opção de selecionar a opção de area nula ou seja, para filtrar registros que não possuem a area */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar a area nula */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção da area nula */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    /** Se deve filtrar somente as àreas ativas */
    @Input() somenteAtivas = false;

    /** Ao destruir o multiselect */
    @Output() onDestroy = new EventEmitter<void>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma area';
    @Input() checked = 'Área';
    @Input() checkedPlural = 'Áreas';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma área encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    areas: AreaFormSelect[];

    constructor(private messageService: MessageService,
                private areaSearchHttpService: AreaSearchHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-area ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria o filter para pesquisar as areas */
    private createFilter(): AreaFilter {
        const filter = new AreaFilter();

        // Somente ativas
        if (this.somenteAtivas) {
            filter.situacoes = [areaSituacaoAtiva.id];
        }

        return filter;
    }

    /** Cria as áreas para o multiselect */
    private create() {
        this.areas = [];
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter  = this.createFilter();
        this.areaSearchHttpService.search(filter, AreaSearchOrderBy.Nome, 'asc', -1, -1)
            .pipe(
                take(1)
            )
            .subscribe(
                areas => {
                    // Adicionando as áreas ao multiselect
                    if (areas) {
                        // Adicionando a opção de "Sem Área"
                        if (this.showNullOption) {
                            selects.push({
                                id: 0,
                                name: 'SEM ÁREA'
                            });
                        }

                        // Áreas
                        areas.forEach(area => {
                            selects.push({
                                id: area.id,
                                name: area.nome
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar as áreas', error);
                }
            );
    }

    /** Ao alterar a seleção da opção área nula */
    private onChangeNullOption() {
        this.nullOption = this.idsAreas.includes(0);
        this.nullOptionChange.emit(this.nullOption);

    }

    /** Ao alterar a seleção das áreas */
    onChange() {
        this.onChangeNullOption();
        this.idsAreasChange.emit(this.idsAreas);
    }

    ngOnDestroy() {
        this.onDestroy.emit();
    }
}
